import { render, staticRenderFns } from "./EditUiSlider.vue?vue&type=template&id=198647db"
import script from "./EditUiSlider.vue?vue&type=script&lang=ts"
export * from "./EditUiSlider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports